import React, { useLayoutEffect } from "react";
import _ from "lodash";

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import {
  getTooltip,
  getXYChart,
  addCursor,
  getRenderAxisX,
  getRenderAxisY,
  addSeriesBullet,
  addLicense,
} from "./commons";

function ProgressChart({ intl, id, data }) {
  useLayoutEffect(() => {

    addLicense()

    var root = am5.Root.new(id);

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([am5themes_Animated.new(root)]);

    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    var chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        layout: root.verticalLayout,
      })
    );

    // Add legend
    // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
    var legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.p50,
        x: am5.p50,
      })
    );

    // Create axes
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
    var yAxis = chart.yAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "category",
        renderer: am5xy.AxisRendererY.new(root, {}),
      })
    );
    yAxis.data.setAll([{ category: "" }]);

    var xAxis = chart.xAxes.push(
      am5xy.ValueAxis.new(root, {
        min: 0,
        max: 100,
        numberFormat: "#'%'",
        renderer: am5xy.AxisRendererX.new(root, {}),
      })
    );

    xAxis.get("renderer").labels.template.set("forceHidden", true);

    // Add series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
    var series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        xAxis: xAxis,
        yAxis: yAxis,
        valueXField: "to",
        openValueXField: "from",
        categoryYField: "category",
        categoryXField: "name",
      })
    );

    series.columns.template.setAll({
      strokeWidth: 0,
      strokeOpacity: 0,
      height: am5.percent(100),
      templateField: "columnSettings",
    });

    series.data.setAll(data);

    // Create axis ranges for each column
    // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/axis-ranges/
    for (var i = 0; i < data.length; i++) {
      var rangeDataItem = xAxis.makeDataItem({
        value: data[i].from,
      });

      var range = xAxis.createAxisRange(rangeDataItem);

      rangeDataItem.get("grid").set("forceHidden", true);

      rangeDataItem.get("tick").setAll({
        visible: false,
        length: 18,
        strokeOpacity: 0.2,
      });

      rangeDataItem.get("label").setAll({
        centerX: am5.p0,
        forceHidden: true,
        fontSize: 10,
        text: data[i].from + "%",
      });
    }

    // Add legend
    // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
    var legend = chart.children.push(
      am5.Legend.new(root, {
        nameField: "categoryX",
        centerX: am5.percent(50),
        x: am5.percent(50),
        marginTop: 20,
        fontSize: 10,
        opacity: 0.75,
        clickTarget: "none",
      })
    );

    legend.markerRectangles.template.setAll({
      strokeOpacity: 0,
    });

    legend.data.setAll(series.dataItems);

    // Make stuff animate on load
    // https://www.amcharts.com/docs/v5/concepts/animations/
    series.appear();
    chart.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [data, id]); // eslint-disable-line react-hooks/exhaustive-deps

  return <div id={id} style={{ minWidth: "800px", minHeight: "150px" }} />;
}

export default React.memo(ProgressChart, (props, nextProps) => {
  return _.isEqual(props.data, nextProps.data);
});
